<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { getFormattedDate, getFormattedTime } from '@/utils/helpers';
import { compartirEnlace } from '@/utils/compartir';
import { redirigirALogin } from '@/utils/subastaRedirections';
import { useRouter } from 'vue-router';

const props = defineProps({
  LotesSubastaStore: Object,
});

const auction = computed(() => props.LotesSubastaStore.auction);
const isLogged = ref(null)
const router = useRouter()
const { appContext } = getCurrentInstance();
const storage_path = appContext.config.globalProperties.storage_path;

onMounted(() => {
  // auction se mantiene sincronizado via computed
    if (localStorage.getItem("token")) {
      isLogged.value=true;
    }
});

</script>
<template>
<div class="container mt-5 pt-4 mt-lg-0 pt-lg-0">
  <div class="card rounded-lg overflow-hidden mt-4 mt-lg-3" style="padding: 0 !important;">
    <!-- Imagen principal con etiqueta -->
    <div class="portada-imagen" v-if="LotesSubastaStore?.auction">
      <img v-if="!auction?.imagen || (!auction?.imagen.hash && !auction?.imagen.archivo)"
        src="@/assets/img/logos/subasta-lote-en-espera.png" class="portada-img-default" alt="Imagen por defecto" />
      <img v-else :src="auction?.imagen?.archivo ??
        `${storage_path}/${auction.imagen.hash}.${auction.imagen.extension}`" class="portada-img"
        alt="Imagen de la subasta" />
      </div>
      
      <div v-else class="portada-placeholder text-center p-4">
        Cargando datos de la subasta...
      </div>
      <div class="w-100 alerta_mensaje d-flex flex-row wrap align-items-center m-0 p-md-2 p-2  justify-content-start">
        <img src="@/assets/img/icons/warning_icon.png" width="23px" class="p-1 ms-3"/>  
        <p class="m-1 text-white">¡Importante! Esta es una subasta <span class="fw-bold">SIN MARTILLERO en vivo</span>. ¿Tenés dudas? Conocé más detalles haciendo <a style="color:white" class="text-white fw-bold text-decoration-underline fs-md-7"  :href="router.resolve({ name: 'ComoParticipar'}).href" target="_blank">click acá</a>.</p>
      </div>
      
    <!-- Información de la subasta -->
    <div class="pt-xl-4 p-xl-5 p-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <!-- Logo a la izquierda -->
      <div v-if="auction?.propietario?.logo?.hash" class="d-flex align-items-center justify-content-start" style="height: 25px;">
        <img
          :src="`${storage_path}/${auction.propietario?.logo?.hash}.${auction.propietario?.logo?.extension}`"
          style="max-width: 108px; max-height: 25px; object-fit: contain;"
          alt="Logo de la empresa"
        />
      </div>
      <!-- Ícono de compartir a la derecha -->

      <div class="d-flex align-items-center gap-3">
        <div class="badge bg-soft-orange text-soft-organge p-2" v-if="LotesSubastaStore?.auction?.privada">
            Subasta interna
        </div>

        <div v-if="auction?.propietario?.logo?.hash" class="d-none d-md-flex acciones d-flex gap-3 text-subtitulos-secondary">
          <img src="@/assets/img/icons/share.svg" style="cursor: pointer;" @click="compartirEnlace"/>  
        </div>
      </div>
    </div>

      <div class="d-sm-flex justify-content-between align-items-center my-1">

        <h5 class="d-none fs-5 d-sm-block portada-titulo mb-0 capitalize-first">
          {{ auction?.titulo || "Título de la Subasta" }}
        </h5>

        <div v-if="!auction?.propietario?.logo?.hash" class="acciones d-flex gap-3 text-subtitulos-secondary mb-3 mb-sm-0">
          <img src="@/assets/img/icons/share.svg" style="cursor: pointer;" @click="compartirEnlace"/> 
        </div>
        <div class="d-flex d-sm-none justify-content-between align-items-center mb-2">
          <h4 class="portada-titulo fw-bold mb-0 capitalize-first">
            {{ auction?.titulo || "Título de la Subasta" }}
          </h4>

          <div class="acciones text-subtitulos-secondary">
            <img
              src="@/assets/img/icons/share.svg"
              style="cursor: pointer;"
              @click="compartirEnlace"
              alt="Compartir"
            />
          </div>
        </div>


      </div>

      <p class="fs-5">
        {{ auction?.subtitulo || "Esperando Información" }}
      </p>

      <div class="d-md-flex flex-wrap gap-5 mt-4 my-3 w-100">
        <!-- Inicio -->
        <div
          class="detalle-item flex-column align-items-start me-5 text-subtitulos-secondary fs-6 fw-bold mb-md-2 mb-sm-0">
          <strong class="fs-6 d-none d-md-flex">Inicia</strong>
          <div class="d-md-flex align-items-center mt-sm-2 mt-1 gap-3">
            <div class="fw-600">
              <i class="fa-regular fa-calendar fs-18 me-1"></i>
              {{ getFormattedDate(auction?.fecha_hora_inicio) || "N/A" }}
            </div>
            <div class="fw-600">
              <i class="fa-regular fa-clock fs-18 me-1"></i>
              {{ getFormattedTime(auction?.fecha_hora_inicio) + " h" || "N/A" }}
            </div>
          </div>
        </div>

        <!-- Finalización -->
        <div class="detalle-item d-none d-md-flex flex-column align-items-start me-5 text-subtitulos-secondary fs-6 fw-bold">
          <strong>Finaliza</strong>
          <div class="d-md-flex align-items-center mt-md-2 mt-1 gap-3">
            <div class="fw-600">
              <i class="fa-regular fa-calendar fs-18 me-1"></i>
              {{ getFormattedDate(auction?.fecha_hora_finalizacion) || "N/A" }}
            </div>
            <div class="fw-600">
              <i class="fa-regular fa-clock fs-18 me-1"></i>
              {{ getFormattedTime(auction?.fecha_hora_finalizacion) + " h" || "N/A" }}
            </div>
          </div>
        </div>

        <!-- ID y Aprobación -->
        <div class="detalle-item d-md-flex flex-column align-items-start text-subtitulos-secondary fs-6 fw-bold">
          <strong class="d-none d-md-flex" style="visibility: hidden;">espacio para ajuste</strong>
          <div class="d-md-flex align-items-center mt-md-2 mt-0 gap-3">
            <div class="fw-600">
              <i class="fa-regular fa-folder fs-18 me-1"></i>
              ID {{ auction?.external_id || "N/A" }}
            </div>
            <div class="fw-600">
              <i class="fa-regular fa-circle-check fs-18 me-1"></i>
              <span v-if="auction?.aprobacion_tiempo_dias && auction?.aprobacion_tiempo_dias > 5">
                Aprobación {{ auction?.aprobacion_tiempo_dias }} días
              </span>
              <span v-else-if="auction?.aprobacion_tiempo_dias && auction?.aprobacion_tiempo_dias <= 5">
                Aprobación {{ auction?.aprobacion_tiempo_dias * 24 }} horas
              </span>
            </div>
          </div>
        </div>
      </div>


      <!-- Botones de acción -->
      <div v-if="!isLogged" class="d-flex flex-column flex-md-row gap-2 mt-5">
        <button type="button" class="btn btn-primary w-100 w-md-20"
          @click="redirigirALogin">
          Registrate
        </button>
      </div>
    </div>
  </div>
</div>
  
</template>
<style>
.detalle-item {
  font-size: 14px;
}

p {
  color: black;
}

.alerta_mensaje{
  background-color: #6EC276;
}
.portada-imagen {
  height: 500px;
  background-color: #EEEEEE;
  display: flex;
  justify-content: center;
  align-items: center;
}


.portada-img-default {
  width: 240px;
  height: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.portada-etiqueta {
  position: absolute;
  top: 50px;
  left: 15px;
  font-size: 0.9rem;
  padding: 5px 10px;
}

.portada-img {
    width: 1150px;
    height: 500px;
    object-fit: cover;
  }

@media (max-width: 768px) {

  .portada-imagen {
    height: 480px;
  }

  .portada-img {
    height: 480px;
  }


}

@media (max-width: 576px) {

  .portada-imagen {
    height: 360px;
  }

  .portada-img {
    height: 360px;
  }

}


@media (max-width: 375px) {

  .portada-imagen {
    height: 220px;
  }

  .portada-img {
    height: 220px;
  }


}

</style>